import React, { useEffect, useState } from 'react';
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import RestauranteSelector from '../Components/CardRest/RestauranteSelector';
import CardapioPopup from '../Components/CardRest/CardapioPopup';
import ResumoPedido from '../Components/CardRest/ResumoPedido';
import Menu from "../../comum/Menu/index.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import AvaliacaoPopup from '../Components/CardRest/AvaliacaoPopup';

const RestauranteFunc = () => {
    const [restaurantes, setRestaurantes] = useState([]);
    const [restauranteSelecionado, setRestauranteSelecionado] = useState(null);
    const [pedido, setPedido] = useState(null);
    const [statusBloqueio, setStatusBloqueio] = useState(false);
    const [mostrarAvaliacao, setMostrarAvaliacao] = useState(false);
    const [confirmacao, setConfirmacao] = useState(false);
    const [ultimadata, setUltimaData] = useState('');
    const [nomeRestaurante, setnomeRestaurante] = useState('');
    const [restav, setRestav] = useState(0);
    const [enviado,setEnviado] = useState(false);
    const chapa = localStorage.getItem("chapa");
    const navigate = useNavigate()
    
     useEffect(() => {
        const chapa = localStorage.getItem("chapa");
        if (!chapa) {
          navigate("/arbor/login"); // Redireciona se não for funcionário logado
        }
      }, []); 

    
    useEffect(() => {
        const fetchRestaurantes = async () => {
            try {
                const res = await api.get(`/restaurante/${chapa}?codigo=0&loja=${localStorage.getItem("loja")}`);
                if (Array.isArray(res.data)) {
                    setRestaurantes(res.data); // agora correto
                    const avaliacaoPendente = res.data.find(r =>
                        r.ultimaav && (r.ultimaav === "0" || r.ultimaav === 0)
                    );
                    if (avaliacaoPendente) {
                        setUltimaData(avaliacaoPendente.ultimadata || '');
                        setMostrarAvaliacao(true);
                        setnomeRestaurante(avaliacaoPendente.nomeultimorest || 'Restaurante');
                        setRestav(avaliacaoPendente.ultimorest)
                        console.log(avaliacaoPendente)
                    } else {
                        const pedidoExistente = res.data.find(r => r.status !== null);
                        if (pedidoExistente) {
                            setPedido({
                                restaurante: pedidoExistente,
                                opcao: pedidoExistente.menu,
                                observacao: pedidoExistente.observacao,
                                hora: pedidoExistente.horasol,
                                turno: pedidoExistente.turno,
                                horaeft: pedidoExistente.status === 1 ? pedidoExistente.horaeft : null
                            });
                            setStatusBloqueio(true);
                            setRestauranteSelecionado(pedidoExistente);
                        }
                    }
                }
            } catch (err) {
                console.error('Erro ao carregar restaurantes:', err);
                Swal.fire('Erro', 'Não foi possível carregar os dados do restaurante.', 'error');
            }
        };

        fetchRestaurantes();
    }, [chapa,mostrarAvaliacao,enviado]);

    const handleSelecionarRestaurante = (restaurante) => {
        if (!statusBloqueio) {
            setRestauranteSelecionado(restaurante);
        }
  
    };

    const handleConfirmarPedido = (dadosPedido) => {
        setPedido(dadosPedido);
        
        if (dadosPedido.restaurante.status === 0 || dadosPedido.restaurante.status === 1 || dadosPedido.status === 0) {
            setStatusBloqueio(true);
            setEnviado(true);
        }
    };

    const handleCancelarPedido = async () => {
        try {
            const res = await api.put(`/restaurante/${chapa}`, { acao: 'CANCELAR' });
            if (res.status === 200) {
                Swal.fire('Cancelado', 'Seu pedido foi cancelado com sucesso.', 'info');
                setEnviado(false);
            } else {
                const msg = res.data?.mensagem || 'Erro ao cancelar pedido';
                Swal.fire('Erro', msg, 'error');
            }
        } catch (err) {
            console.error('Erro ao cancelar pedido:', err);
            let msg = 'Falha na comunicação com o servidor';
            if (err.response?.data?.erro) {
                msg = Array.isArray(err.response.data.erro)
                    ? err.response.data.erro[0]
                    : err.response.data.erro;
            }
            Swal.fire('Erro', msg, 'error');
        } finally {
            setPedido(null);
            setStatusBloqueio(false);
            setRestauranteSelecionado(null);
        }
    };

    if (mostrarAvaliacao) {
        return (
            <AvaliacaoPopup
                usuario={chapa}
                datault={ultimadata}
                codigoRestaurante={restav}
                nomeRestaurante={nomeRestaurante}
                onClose={() => setMostrarAvaliacao(false)}
            />
        );
    }

    return (
        <div>
            <Menu modulo="ARBOR" />
            <div className="container-fluid mt-4">

                <h3><br /></h3>

                {!statusBloqueio && (
                    <RestauranteSelector
                        usuario={chapa}
                        onSelecionar={handleSelecionarRestaurante}
                        bloqueado={statusBloqueio}
                        restaurantes={restaurantes.filter(r => r.status === null)}
                    />
                )}
                {!statusBloqueio && (
                    <CardapioPopup
                        usuario={chapa}
                        restaurante={restauranteSelecionado}
                        onClose={() => setRestauranteSelecionado(null)}
                        onConfirm={handleConfirmarPedido}
                        onCancelar={handleCancelarPedido}
                    />
                )}
                {pedido && <ResumoPedido pedido={pedido} onCancelar={handleCancelarPedido} />}

            </div>
            <Footer className="footer navbar-fixed-bottom" />
        </div>
    );
};

export default RestauranteFunc;
